const fromStoreByByIdQueryToStoreById = (storeQuery) => {
  if (!storeQuery) {
    return null;
  }
  try {
    const { globalStoreId, name, streetName, streetNumber, town } = storeQuery;
    return {
      globalStoreId,
      name,
      streetName,
      streetNumber: streetNumber ?? void 0,
      town
    };
  } catch (e) {
    console.error(
      "Store search query data adapter failed to parse input data correctly.",
      e,
      storeQuery
    );
    return null;
  }
};
export {
  fromStoreByByIdQueryToStoreById as default
};
//# sourceMappingURL=fromStoreByByIdQueryToStoreById.js.map
